const input = document.getElementById('dev_snu-search-input');
const gmapApiKey = 'AIzaSyD2QJc5URYVEWP9BRWpSSpENbIx89BanIU';
const gmapToConvertLatLongToPin = 'AIzaSyAaqSOJX04_K5Qhu-t1U2wFr0FHGZKCK6o';
const storeContainer = document.getElementById('dev_snu-store-card-parent');
const mapView = document.getElementById('dev_snu-map-view');
const storeStaticData = document.getElementById('dev_snu-store-static-content-mobile');
let map;
let searchTimeout;
let autocompleteService;
let placesService;
let searchDropdown;
const tabs = document.querySelectorAll('.snu-tab');
const listView = document.getElementById('dev_snu-store-card-parent');

(function () {
      var overlay        = document.getElementById('physioOverlay');
      var openBtn         = document.getElementById('physioOpenBtn');
      var mobileOpenBtn   = document.getElementById('mobile_physioOpenBtn');
      var closeBtn         = document.getElementById('physioCloseBtn');

      function openPhysioPopup(e) {
        if (e) e.preventDefault();
        overlay.classList.add('is-open');
        document.body.classList.add('physio-popup-locked');
      }

      function closePhysioPopup() {
        overlay.classList.remove('is-open');
        document.body.classList.remove('physio-popup-locked');
      }

      if (openBtn) {
        openBtn.addEventListener('click', openPhysioPopup);
      }

      if (mobileOpenBtn) {
        mobileOpenBtn.addEventListener('click', openPhysioPopup);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closePhysioPopup);
      }

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closePhysioPopup();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
          closePhysioPopup();
        }
      });

      window.openPhysioPopup = openPhysioPopup;
      window.closePhysioPopup = closePhysioPopup;

      function initialPhysioCheck() {
            var storedPincode = localStorage.getItem('popupPincode');
            var storedCityState = null;
            try {
            storedCityState = JSON.parse(localStorage.getItem('mcmCityState') || 'null');
            } catch (e) {}

            if (typeof window.togglePhysioSection === 'function') {
            window.togglePhysioSection(storedCityState, storedPincode);
            }
        }

        initialPhysioCheck();

    })();

    function togglePhysioSection() {
        var storedPincode = localStorage.getItem('popupPincode');
        var pin = parseInt(storedPincode, 10);

        var isMumbaiPincode =
            !isNaN(pin) &&
            ((pin >= 400001 && pin <= 400104) || (pin >= 400601 && pin <= 400710));

        var physioCard = document.querySelector('.physio-pill');
        if (!physioCard) return;

        physioCard.style.display = isMumbaiPincode ? 'flex' : 'none';

        if (!isMumbaiPincode && typeof window.closePhysioPopup === 'function') {
            window.closePhysioPopup();
        }
    }

    window.togglePhysioSection = togglePhysioSection;

    // Single source of truth for location updates on this page.
    // Keeps popupPincode, userPincode (with expiry) and mcmCityState in sync
    // every time — mirrors savePincode() on the PDP so the collection page's
    // userPincode-first read never serves a stale pincode from this page.
    function persistLocation(pincode, cityState) {
        if (!pincode) return;
        const pincodeStr = String(pincode);
        localStorage.setItem('popupPincode', pincodeStr);
        localStorage.setItem('userPincode', JSON.stringify({ pincode: pincodeStr, expiry: Date.now() + 1800000 }));
        if (cityState && cityState.state) {
            localStorage.setItem('mcmCityState', JSON.stringify({
                city: cityState.city || null,
                state: cityState.state,
                pincode: pincodeStr
            }));
        }
        if (typeof window.togglePhysioSection === 'function') {
            window.togglePhysioSection();
        }
    }
function initializePlacesServices() {
    if (window.google && window.google.maps && window.google.maps.places) {
        autocompleteService = new google.maps.places.AutocompleteService();
        const mapDiv = document.createElement('div');
        mapDiv.style.display = 'none';
        document.body.appendChild(mapDiv);
        const tempMap = new google.maps.Map(mapDiv, {
            center: { lat: 0, lng: 0 },
            zoom: 1
        });
        placesService = new google.maps.places.PlacesService(tempMap);
        setTimeout(() => {
            document.body.removeChild(mapDiv);
        }, 100);
        
        return true;
    }
    return false;
}

function createSearchDropdown() {
    if (!searchDropdown) {
        searchDropdown = document.createElement('div');
        searchDropdown.className = 'snu-search-dropdown';
        searchDropdown.style.cssText = `
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            margin-top: 8px;
            background: white;
            border: 1px solid #e0e0e0;
            border-top: none;
            border-radius: 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            max-height: 300px;
            overflow-y: auto;
            z-index: 1000;
            display: none;
        `;
        input.parentElement.style.position = 'relative';
        input.parentElement.appendChild(searchDropdown);
    }
}

function showSearchSuggestions(predictions) {
    if (!searchDropdown) createSearchDropdown();
    
    searchDropdown.innerHTML = '';
    searchDropdown.style.display = 'block';
    
    predictions.forEach(prediction => {
        const item = document.createElement('div');
        item.className = 'snu-search-item';
        item.style.cssText = `
            padding: 12px 16px;
            cursor: pointer;
            border-bottom: 1px solid #f0f0f0;
            transition: background-color 0.2s;
        `;
        item.innerHTML = `
            <div style="display: flex; align-items: center;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2" style="margin-right: 8px; flex-shrink: 0;">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <div>
                    <div style="color: #333; font-size: 14px;">${prediction.structured_formatting.main_text}</div>
                    <div style="color: #666; font-size: 12px; margin-top: 2px;">${prediction.structured_formatting.secondary_text || ''}</div>
                </div>
            </div>
        `;
        
        item.addEventListener('mouseenter', () => {
            item.style.backgroundColor = '#f5f5f5';
        });
        
        item.addEventListener('mouseleave', () => {
            item.style.backgroundColor = 'white';
        });
        
        item.addEventListener('click', () => {
            selectPlace(prediction);
        });
        
        searchDropdown.appendChild(item);
    });
}

function hideSearchDropdown() {
    if (searchDropdown) {
        searchDropdown.style.display = 'none';
    }
}

// Select a place from suggestions
function selectPlace(prediction) {
    const searchTerm = prediction.description;
    input.value = searchTerm;
    hideSearchDropdown();
    
    placesService.getDetails({
        placeId: prediction.place_id,
        fields: ['geometry', 'address_components', 'name']
    }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place.geometry) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            
            let pincode = null;
            if (place.address_components) {
                const postalComponent = place.address_components.find(component => 
                    component.types.includes('postal_code')
                );
                if (postalComponent) {
                    pincode = postalComponent.long_name;
                    localStorage.setItem('popupPincode', pincode);
                }

                // FIXED: added const — these were accidental implicit globals before
                const localityComponent = place.address_components.find(c => c.types.includes('locality'));
                const stateComponent = place.address_components.find(c =>
                    c.types.includes('administrative_area_level_1')
                );
                const city = localityComponent ? localityComponent.long_name : null;
                const state = stateComponent ? stateComponent.long_name : null;

                if (pincode) persistLocation(pincode, { city, state });
            }
            
            localStorage.setItem('latitude', lat);
            localStorage.setItem('longitude', lng);
            
            fetchStoreData(pincode || '000000', lat, lng);
        }
    });
}

// Enhanced input handler
input.addEventListener('input', function() {
    const value = input.value.trim();
    
    clearTimeout(searchTimeout);
    
    if (/^\d{6}$/.test(value)) {
        hideSearchDropdown();
        input.blur();
        persistLocation(value, null);
        localStorage.removeItem('latitude');
        localStorage.removeItem('longitude');
        fetchStoreData(value, null, null);

        getCityStateForCache(value);
        return;
    }
    
    if (value.length >= 3) {
        searchTimeout = setTimeout(() => {
            searchLocation(value);
        }, 300);
    } else {
        hideSearchDropdown();
    }
});

// Resolves city/state via TSC pincode geocode API and caches it
async function getCityStateForCache(pincode) {
    try {
        const response = await fetch(`https://app.thesleepcompany.in/vendor/v1/api/edd/v1/pincode/${pincode}/geocode`, {
            headers: { 'Accept': 'application/json', 'x-api-key': 'ak_1YDJeoRCQ9rHNhENXKgcKODVVVb-Sf1Ag5k8CRhrOpQ' }
        });
        const data = (await response.json())?.data;
        if (data && data.status === 'OK' && data.results.length) {
            const comps = data.results[0].address_components;
            const city = comps.find(c => c.types.includes('locality'))?.long_name || null;
            const state = comps.find(c => c.types.includes('administrative_area_level_1'))?.long_name || null;
            if (state) {
                persistLocation(pincode, { city, state });
            }
        }
    } catch (e) {
        console.warn('Could not resolve city/state for cache:', e);
    }
}
// REMOVED: leftover manual debug call that was overwriting mcmCityState with
// pincode 400001 on every single page load, regardless of the real pincode.
// This was the actual live bug causing the wrong city/state to appear.

function searchLocation(query) {
    if (!autocompleteService) {
        if (!initializePlacesServices()) {
            console.error('Google Places services not available yet');
            return;
        }
    }
    
    if (!autocompleteService) {
        console.error('AutocompleteService still not available');
        return;
    }
    
    const request = {
        input: query,
        componentRestrictions: { country: 'IN' },
        types: ['geocode', 'establishment']
    };
    
    autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
            showSearchSuggestions(predictions);
        } else {
            hideSearchDropdown();
        }
    });
}

input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
        e.preventDefault();
        const value = input.value.trim();
        
        if (searchDropdown && searchDropdown.style.display === 'block') {
            const firstItem = searchDropdown.querySelector('.snu-search-item');
            if (firstItem) {
                firstItem.click();
                return;
            }
        }
        
        if (value && !(/^\d{6}$/.test(value))) {
            geocodeAddress(value);
        }
    }
});

function geocodeAddress(address) {
    const geocoder = new google.maps.Geocoder();
    
    geocoder.geocode({ 
        address: address,
        componentRestrictions: { country: 'IN' }
    }, (results, status) => {
        if (status === 'OK' && results[0]) {
            const result = results[0];
            const lat = result.geometry.location.lat();
            const lng = result.geometry.location.lng();
            
            let pincode = null;
            const postalComponent = result.address_components.find(component => 
                component.types.includes('postal_code')
            );
            if (postalComponent) {
                pincode = postalComponent.long_name;
                localStorage.setItem('popupPincode', pincode);
            }

            const localityComponent = result.address_components.find(c => c.types.includes('locality'));
            const stateComponent = result.address_components.find(c =>
                c.types.includes('administrative_area_level_1')
            );
            const city = localityComponent ? localityComponent.long_name : null;
            const state = stateComponent ? stateComponent.long_name : null;
            if (pincode) persistLocation(pincode, { city, state });
            
            localStorage.setItem('latitude', lat);
            localStorage.setItem('longitude', lng);
            
            input.value = result.formatted_address;
            hideSearchDropdown();
            
            fetchStoreData(pincode || '000000', lat, lng);
        } else {
            alert('Location not found. Please try a different search term.');
        }
    });
}

document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && (!searchDropdown || !searchDropdown.contains(e.target))) {
        hideSearchDropdown();
    }
});

input.placeholder = "Search by area, city, landmark or pincode";

input.removeAttribute('inputmode');
input.removeAttribute('pattern');
input.removeAttribute('maxlength');

if (window.google && window.google.maps) {
    setTimeout(() => {
        initializePlacesServices();
    }, 500);
} else {
    const checkGoogleMaps = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
            initializePlacesServices();
            clearInterval(checkGoogleMaps);
        }
    }, 100);
}

window.initializePlacesOnMapLoad = function() {
    setTimeout(() => {
        initializePlacesServices();
    }, 500);
};

async function fetchStoreData(postcode, lat = null, long = null) {
    let apiUrl = '';

    if (lat && long) {
        postcode = '000000';
        apiUrl = `https://api.thesleepcompany.in/stores?latitude=${lat}&longitude=${long}&pincode=${postcode}`;
    } else {
        apiUrl = `https://api.thesleepcompany.in/stores?pincode=${postcode}`;
    }

    const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';
    const headers = new Headers({
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
    });

    try {
        const res = await fetch(apiUrl, { method: 'GET', headers });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        const apiData = data.stores;
        const pincodeStr = String(postcode || '').trim();

        if (!apiData || apiData.length === 0) {
            if (typeof updateWorkFromStoreBanner === 'function') {
                updateWorkFromStoreBanner({ pincode: pincodeStr, stores: [], hide: true });
            }
            document.getElementById('dev_snu-store-count').textContent = '0 ';
            storeContainer.innerHTML = `<div style="text-align: center; padding: 40px 20px; color: #666;">Looks like we're not in your city yet but you can still explore our range and shop online</div>`;
            document.getElementById('dev_snu-stores-section').style.display = 'block';
            
            initMap([]);
            updateStoreStatus();
            return;
        }

        const storeData = apiData
            .filter((store) => store?.distance != null && store?.distance <= 100 && store?.distance >= 0)
            .sort((a, b) => a.distance - b.distance);

        document.getElementById('dev_snu-store-count').textContent = storeData.length + ' ';

        if (storeData.length === 0) {
            if (typeof updateWorkFromStoreBanner === 'function') {
                updateWorkFromStoreBanner({ pincode: pincodeStr, stores: [], hide: true });
            }
            storeContainer.innerHTML = `<div style="text-align: center; padding: 40px 20px; color: #666;">Looks like we're not in your city yet but you can still explore our range and shop online.</div>`;
            document.getElementById('dev_snu-stores-section').style.display = 'block';
            
            initMap([]);
            return;
        }

        if (typeof updateWorkFromStoreBanner === 'function') {
            updateWorkFromStoreBanner({
                stores: storeData,
                pincode: pincodeStr
            });
        }
        updateStoreCards(storeData);
        initMap(storeData);
        if(storeData.length > 0) {
            const isMumbaiStore = storeData.some(store => store.city.includes("Mumbai"));
            const isBengaluruStore = storeData.some(store => store.city.includes("Bengaluru"));
            const containerWidgets = document.querySelectorAll('.next-day-widget-our-store-page');
            if(containerWidgets.length > 0) {
                containerWidgets.forEach(widget => {
                   if(isMumbaiStore || isBengaluruStore) { 
                     widget.classList.remove('hidden');
                   } else {
                     widget.classList.add('hidden');
                   }
                });
              console.log("MUMBAI STORE FOUND IN API RESPONSE");
            } 
        }
        console.log("Fetched store data ==> ", storeData);
        togglePhysioSection();
    } catch (error) {
        console.error('Error fetching store data:', error.message);
        if (typeof updateWorkFromStoreBanner === 'function') {
            updateWorkFromStoreBanner({ hide: true });
        }
        const physioCard = document.querySelector('.physio-pill');
        if (physioCard) {
            physioCard.style.display = 'none';
        }
    }
    updateStoreStatus();

    gaEvent('store_near_you', [document.getElementById('dev_snu-search-input').value, "", "", "", "", ""], false);
}

function showLocationPopup() {
    const popup = document.getElementById('location-permission-popup');
    popup.style.display = 'flex';
    document.body.classList.add('modal-open');
}

function hideLocationPopup() {
    const popup = document.getElementById('location-permission-popup');
    popup.style.display = 'none';
    document.body.classList.remove('modal-open');
}

function handleGeolocationClick() {
    console.log("Geolocation button clicked");
    if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                console.log("Geolocation position ==> ", position);
                const lat = position.coords.latitude;
                const long = position.coords.longitude;

                localStorage.setItem('latitude', lat);
                localStorage.setItem('longitude', long);

                try {
                    console.log("Fetching address for lat: ", lat, " long: ", long);
                    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${gmapToConvertLatLongToPin}`);
                    const data = await response.json();
                    console.log("Geolocation address data ==> ", data);

                    if (data.status === "OK") {
                        const addressComponents = data.results[0].address_components;
                        const postcode = addressComponents.find(comp => comp.types.includes("postal_code"))?.long_name;

                        const stateComp = addressComponents.find(comp => comp.types.includes("administrative_area_level_1"))?.long_name || null;
                        const cityComp = addressComponents.find(comp => comp.types.includes("locality"))?.long_name || null;
                        
                        if (postcode) {
                            console.log("postcode ==> ", postcode);
                            persistLocation(postcode, { city: cityComp, state: stateComp });
                            input.value = postcode;

                            if (stateComp) {
                                localStorage.setItem('mcmCityState', JSON.stringify({ city: cityComp, state: stateComp, pincode: postcode }));
                            }
                        } else {
                            const locality = addressComponents.find(comp => comp.types.includes("locality"))?.long_name || "";
                            const sublocality = addressComponents.find(comp => comp.types.includes("sublocality"))?.long_name || "";
                            const displayAddress = sublocality ? `${sublocality}, ${locality}` : locality || "Current Location";
                            input.value = displayAddress;
                            console.log("displayAddress ==> ", displayAddress);
                        }
                    }
                } catch (error) {
                    console.log("error ==> ", error);
                }
                
                fetchStoreData('ignored', lat, long);
            },
            (error) => {
                console.error('Geolocation error:', error.message);
                if (error.code === error.PERMISSION_DENIED) {
                    showLocationPopup();
                }
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            }
        );
    } else {
        console.error('Geolocation is not supported by this browser.');
        alert('Geolocation is not supported by this browser. Please enter your pincode manually.');
    }
}

let markers = [];

function initMap(stores) {
    const userLat = parseFloat(localStorage.getItem('latitude'));
    const userLng = parseFloat(localStorage.getItem('longitude'));

    const hasUserLocation = !isNaN(userLat) && !isNaN(userLng);
    const defaultLocation = hasUserLocation ? { lat: userLat, lng: userLng } : { lat: 21.1702, lng: 72.8311 };

    map = new google.maps.Map(document.getElementById('dev_snu-map-view'), {
        center: defaultLocation,
        zoom: 11,
    });

    const bounds = new google.maps.LatLngBounds();
    const infoWindow = new google.maps.InfoWindow();
    
    markers = [];

    if (stores && stores.length > 0) {
        stores.forEach((store, index) => {
            const lat = parseFloat(store.latitude);
            const lng = parseFloat(store.longitude);

            if (!isNaN(lat) && !isNaN(lng)) {
                const marker = new google.maps.Marker({
                    position: { lat, lng },
                    map: map,
                    title: store.storeName,
                    icon: {
                        url: "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Group_1707478864.png?v=1746386524",
                        scaledSize: new google.maps.Size(32, 32),
                    },
                    storeId: store.storeId
                });

                markers.push({
                    marker: marker,
                    storeId: store.storeId
                });

                marker.addListener('click', () => {
                    const contentString = `
                        <div style="max-width: 250px;font-family: Arial, sans-serif;padding-right: 12px;">
                            <p style="line-height: normal; margin: 4px 0; font-size: 13px;"><strong>Address:</strong> ${store.address}</p>
                            <p style="line-height: normal; margin: 8px 0 0; font-size: 13px;"><strong>Distance:</strong> ${Math.round(store.distance)}km </p>
                            <a href="https://www.google.com/maps/dir/?api=1&destination=${store.latitude},${store.longitude}" target="_blank" style="font-size: 12px;color: #1a73e8;text-align: center; marging-bottom: 8px;display: flex;">🧭 Get Directions</a>
                            <p style="line-height: normal; margin: 4px 0; font-size: 13px;"><strong>Timings:</strong> ${store.storeTimings}</p>
                            <p style="line-height: normal; margin: 4px 0; font-size: 13px;"><strong>Contact:</strong> <a href="tel:${store.contact}" style="color: #1a73e8; text-decoration: none; font-size: 13px">${store.contact}</a></p>
                            <p style="cursor: pointer;font-size: 13px;color: #1a73e8;text-align: center; marging-bottom: 8px;display: flex;" class="dev_snu-appointment-btn" data-store-locid="${store.storeId}" data-store-loctitle="${store.getStoreLocationKey}">Book a visit </p>
                            <a href="${store.mapLink}" target="_blank" style="display: inline-block;margin-top: 8px;font-size: 13px;color: #1a73e8;text-decoration: underline;margin-bottom: 10px;text-decoration: auto;background: #e7f8fe;padding: 4px 8px;border-radius: 8px;width: 100%;text-align: center;position: sticky;bottom: 0;">📍 View in Google Maps</a>
                        </div>
                    `;

                    infoWindow.setContent(contentString);
                    infoWindow.open(map, marker);

                    google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
                        const titleContainer = document.querySelector('.gm-style-iw-ch');
                        if (titleContainer) {
                            titleContainer.innerText = store.getStoreLocationKey;
                            titleContainer.style.fontSize = '15px';
                            titleContainer.style.fontWeight = 'bold';
                            titleContainer.style.color = '#0a2540';
                        }
                    });
                    
                    highlightMarker(marker);
                });

                bounds.extend(marker.position);
            }
        });
    }

    if (hasUserLocation) {
        const userLatLng = new google.maps.LatLng(userLat, userLng);

        const userMarker = new google.maps.Marker({
            position: userLatLng,
            map: map,
            title: 'Current Location',
            icon: {
                url: "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Group_1707478871.png?v=1746429881",
                scaledSize: new google.maps.Size(34, 34),
                anchor: new google.maps.Point(17, 17),
            }
        });

        bounds.extend(userLatLng);
    }

    if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
        
        const listener = google.maps.event.addListener(map, "idle", function() { 
            if (map.getZoom() > 14) map.setZoom(14);
            google.maps.event.removeListener(listener); 
        });
    }
}

function highlightMarker(marker) {
    resetAllMarkers();
    
    marker.setAnimation(google.maps.Animation.BOUNCE);
    
    map.panTo(marker.getPosition());
    
    map.setZoom(14);
    
    setTimeout(() => {
        marker.setAnimation(null);
    }, 2000);
}

function resetAllMarkers() {
    markers.forEach(item => {
        item.marker.setAnimation(null);
        item.marker.setIcon({
            url: "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Group_1707478864.png?v=1746386524",
            scaledSize: new google.maps.Size(32, 32),
        });
    });
}

function findMarkerByStoreId(storeId) {
    const found = markers.find(item => item.storeId === storeId);
    return found ? found.marker : null;
}

function updateStoreCards(stores) {
    storeContainer.innerHTML = '';
    const fragment = document.createDocumentFragment();

    stores.forEach((store, index) => {
        const card = document.createElement('div');
        card.className = 'snu-store-card';

        const firstTimeElement = document.createElement('div');
        firstTimeElement.className = 'firstTimeElement';

        var openBadge = store.is_open_now ? `<div class="snu-open-badge">Open Now</div>` : '';
        const distanceBadge = Math.round(store.distance)
            ? `<div class="snu-distance-badge hide-dsk"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.72732 1.02565L10.6035 3.75686C11.0876 3.90582 11.1427 4.56906 10.6896 4.79559L6.92764 6.67658C6.81899 6.73091 6.73084 6.81905 6.67651 6.92771L4.79563 10.6896C4.5691 11.1426 3.906 11.0877 3.75704 10.6036L1.02564 1.72716C0.893091 1.29636 1.29653 0.893097 1.72732 1.02565Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>${Math.round(store.distance)} Kms</div>`
            : '';
        const distanceBadgeDesktop = Math.round(store.distance)
            ? `<div class="snu-distance-badge-desktop hide-mbl"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.72732 1.02565L10.6035 3.75686C11.0876 3.90582 11.1427 4.56906 10.6896 4.79559L6.92764 6.67658C6.81899 6.73091 6.73084 6.81905 6.67651 6.92771L4.79563 10.6896C4.5691 11.1426 3.906 11.0877 3.75704 10.6036L1.02564 1.72716C0.893091 1.29636 1.29653 0.893097 1.72732 1.02565Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>${Math.round(store.distance)} Kms</div>`
            : '';
        var openNow = Math.round(store.distance)
            ? `<div class="snu-open-now dev_all-snup-open-now"> <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none"><circle cx="4" cy="4.74805" r="4" fill="#2E7D32"/></svg> Open Now </div>`
            : '';

        if(store.comingSoon){
            openBadge = '';
            openNow = '<span class="snu-coming-soon">Coming Soon</span>';
        }
        const rating = store.storeRating || '4.8';
        const reviewCount = store.reviewCount || '1,000+';
        const storeName = store.storeName || 'The Sleep Company Store';
        const storeId = store.storeId;
        const storeUrl = store.storeUrl;
        
        const defaultImage = 'https://cdn.shopify.com/s/files/1/0635/6929/7637/files/I_visited_THE_SLEEP_COMPANY_store_For_Shopping_in_THE_GREAT_INDIAN_SLEEP_SALE_2024_1.png?v=1745830261';
        let storeImages = [];
        
        if (store.image && Array.isArray(store.image) && store.image.length > 0) {
            storeImages = store.image;
        } else if (store.image_url) {
            storeImages = [store.image_url];
        } else {
            storeImages = [defaultImage];
        }
        
        const storeLocation = store.address || 'Location not available';
        const phone = store.contact || '9811981911';
        const timings = store.storeTimings || '11:00 AM to 10:00 PM';
        const storeGetLocation = store.getStoreLocationKey;
        const bookVisitWhatsapp = `https://api.whatsapp.com/send/?phone=919152131284&text=${encodeURIComponent(`Book my visit at ${storeGetLocation}`)}&type=phone_number&app_absent=0`;
        const mapsLink = `https://api.whatsapp.com/send/?phone=919152131284&text=Share+me+map+location+of+${encodeURIComponent(storeGetLocation)}&type=phone_number&app_absent=0`;
        const parkingInfo = store.parking || null;
        // Generate the image HTML - basic approach with multiple images
        let imageHTML = '';
        for (let i = 0; i < storeImages.length; i++) {
            imageHTML += `<img src="${storeImages[i]}" alt="Store" class="snu-store-image">`;
        }

        card.innerHTML = `
            <a href="${storeUrl}" class="snu-store-image-container">
                ${openBadge}
                ${distanceBadge}
                ${openNow}
                <div class="snu-store-image-slider-contianer">${imageHTML}</div>
            </a>
            <div class="snu-store-details">
                <a href="${storeUrl}" class="snu-store-header">
                    <div class="snu-store-name-and-desc">
                        <div class="snu-store-name" data-store-id="${storeId}">${storeName}</div>
                        <div class="snu-location">
                            <span class="snu-location-pin">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14" fill="none">
                                <path d="M4.99707 0.25H5.00293C6.81563 0.250052 8.90855 1.50003 9.55566 4.3418L9.61328 4.62207C10.2115 7.82098 8.73579 10.5704 7.23633 12.4316L6.9375 12.792L6.93652 12.793C6.38868 13.4381 5.69001 13.75 5.00293 13.75C4.35888 13.75 3.70467 13.4758 3.16895 12.9092L3.06348 12.792H3.0625C1.51936 10.9932 -0.143654 8.20803 0.333984 4.93359L0.386719 4.61523C0.956505 1.57619 3.13091 0.250054 4.99707 0.25ZM5.00293 3.44434C3.84176 3.44434 2.97858 4.56657 2.97852 5.8457C2.97852 7.1249 3.84172 8.24707 5.00293 8.24707C6.16408 8.247 7.02734 7.12486 7.02734 5.8457C7.02728 4.56661 6.16404 3.44441 5.00293 3.44434Z" fill="#1A2B58" stroke="#1A2B58" stroke-width="0.5"/>
                            </svg>
                            </span>
                            ${storeGetLocation}
                        </div>
                    </div>
                    <div class="snu-rating">
                        <div class="snu-rating-stars">
                            <span class="snu-google-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#4285F4">
                                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                                </svg>
                            </span>
                            ${rating}
                        </div>
                        <span class="snu-reviews">(${reviewCount} reviews)</span>
                    </div>
                </a>
                <a href="${storeUrl}"  class="snu-timing">
                   <span class="snu-timing-parking">
                    <span class="snu-timing-label">Timings: ${timings}</span>
                    ${parkingInfo ? `<span class="snu-parking-label">${parkingInfo.includes('Free') || parkingInfo.includes('Paid') ? 'Parking Available' : parkingInfo.includes('Valet') ? 'Valet Parking Available' : ''}</span>` : ''}
                   </span>
                    ${distanceBadgeDesktop}
                </a>
                <div class="snu-contact-actions">
                    <a data-position="Store Page List" data-storename="${storeName}" href="tel:${phone}" class="snu-phone-link dev_snu-phone-link">
                        <span class="snu-phone-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <rect width="20" height="20" fill="white"/>
                                <path d="M8.11962 3.7425C7.87269 3.12891 7.27478 2.72656 6.60989 2.72656H4.37346C3.52269 2.72656 2.83301 3.41189 2.83301 4.2575C2.83301 11.4451 8.6955 17.272 15.927 17.272C16.7778 17.272 17.4673 16.5865 17.4673 15.7409L17.4677 13.5176C17.4677 12.8568 17.063 12.2626 16.4457 12.0172L14.3022 11.1653C13.7477 10.9448 13.1163 11.0441 12.6575 11.4241L12.1043 11.8827C11.4582 12.4178 10.5076 12.3752 9.91292 11.7842L8.3552 10.2345C7.76053 9.64343 7.71659 8.69936 8.25498 8.05722L8.71627 7.50741C9.09862 7.05138 9.19933 6.42366 8.97752 5.8725L8.11962 3.7425Z" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        +91 ${phone}
                    </a>
                    <div data-position="Get location - Store Page List" data-href="${mapsLink}" target="_blank" class="snu-location-link dev_ga-snu-appointment-btn-store-card">
                        <span class="snu-whatsapp-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884z"/>
                            </svg>
                        </span>
                        Get location
                    </div>
                </div>
                <div class="snu-appointment-prnt"> 
                    <div data-position="Get location - Book Free Appointment" data-href="${bookVisitWhatsapp}" class="snu-appointment-btn dev_ga-snu-appointment-btn-store-card" data-store-locid="${storeId}" data-store-loctitle="${storeGetLocation}">Schedule Your Store Visit</div> 
                </div>
            </div>
        `;

        fragment.appendChild(card);

        if (index === 0) {
            firstTimeElement.innerHTML = `<div class="thesleep-lab tsl-wrapper">
            <div class="tsl-header">
                <div class="tsl-text-wrapper">
                <span class="tsl-title">In-Store Comfort Experience</span>
                <p class="tsl-subtitle">Beyond Ordinary</p>
                </div>

                <div class="tsl-card-container">
                    <div class="tsl-card">
                        <div class="tsl-card-img"><img src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/original-6430C5CD-2C11-4059-9AD6-C82D0EF6C353.jpg?v=1748241651&width=300" loading="lazy"/></div>
                        <div class="tsl-card-text-wrapper">
                            <p class="tsl-card-title">Japanese Patented SmartGRID</p>
                            <p class="tsl-card-text">
                                Experience the comfort tech revolution with India's 1st & only SmartGRID mattresses.
                            </p>
                        </div>
                    </div>

                    <div class="tsl-card">
                        <div class="tsl-card-img"><img src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/original-45228CB5-525E-4952-9DC8-C0A0DECF0DAF.jpg?v=1748241652&width=300" loading="lazy"/></div>
                        <div class="tsl-card-text-wrapper">
                            <p class="tsl-card-title">Certified Expert Consultation</p>
                            <p class="tsl-card-text">
                                In-store sleep experts help you make the right choice based on your sleep patterns.
                            </p>
                        </div>
                    </div>

                    <div class="tsl-card">
                        <div class="tsl-card-img"><img src="https://cdn.shopify.com/s/files/1/0635/6929/7637/files/original-DE9F1F32-A4B2-469B-B780-A5809C0828CF.jpg?v=1748241652&width=300" loading="lazy"/></div>
                        <div class="tsl-card-text-wrapper">
                            <p class="tsl-card-title">Trusted by 4 Lakh+ Customers</p>
                            <p class="tsl-card-text">
                                Our products are loved, rated, and trusted by over 4 lakh happy customers.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tsl-features">
                <div class="tsl-text-wrapper">
                <span class="tsl-features-title">EXPERIENCE CENTRE</span>
                <p class="tsl-features-subtitle">FEATURES</p>
                </div>
                <div class="tsl-features-container">
                <div class="tsl-feature">
                    <div class="tsl-feature-img"></div>
                    <p class="tsl-feature-title">Lorem Ipsum</p>
                </div>

                <div class="tsl-feature">
                    <div class="tsl-feature-img"></div>
                    <p class="tsl-feature-title">Lorem Ipsum</p>
                </div>

                <div class="tsl-feature">
                    <div class="tsl-feature-img"></div>
                    <p class="tsl-feature-title">Lorem Ipsum</p>
                </div>

                <div class="tsl-feature">
                    <div class="tsl-feature-img"></div>
                    <p class="tsl-feature-title">Lorem Ipsum</p>
                </div>
                </div>
            </div>`

            fragment.appendChild(firstTimeElement);
            document.getElementById('dev_snu-store-static-content-mobile').innerHTML = firstTimeElement.innerHTML;
        }
    });

    document.getElementById('dev_snu-stores-section').style.display = 'block';

    storeContainer.appendChild(fragment);
    
    initializeSliders();
    
    attachStoreNameListeners();

    document.querySelectorAll('.dev_snu-phone-link').forEach((btn) => {
        btn.addEventListener('click', function(event) {
            if (typeof showPopup === 'function') { showPopup(event); }
            gaEvent('call_us', [this.getAttribute('data-position'), this.getAttribute('data-storename'), "", "", "", ""], false);  
        });
    });
    document.querySelectorAll('.dev_ga-snu-appointment-btn-store-card').forEach((btn) => {
        btn.addEventListener('click', function() {
            gaEvent('store_visit', [this.getAttribute('data-position'), this.getAttribute('data-href'), "", "", "", ""], false);
            window.location.href = this.getAttribute('data-href');
        });
    });
}

function attachStoreNameListeners() {
    const storeNames = document.querySelectorAll('.snu-store-name');
    
    storeNames.forEach(nameElement => {
        nameElement.style.cursor = 'pointer';
        
        nameElement.style.transition = 'color 0.3s';
        
        nameElement.addEventListener('mouseenter', function() {
            this.style.color = '#0066cc';
        });
        
        nameElement.addEventListener('mouseleave', function() {
            this.style.color = '';
        });
        
        nameElement.addEventListener('click', function() {
            const storeId = this.getAttribute('data-store-id');
            const marker = findMarkerByStoreId(storeId);
            
            if (marker) {
                highlightMarker(marker);
                
                const mapElement = document.getElementById('dev_snu-map-view');
                const isMobile = window.innerWidth < 768;
                
                if (isMobile && mapElement) {
                    mapElement.scrollIntoView({ behavior: 'smooth' });
                }
            }

            if (window.innerWidth <= 768) {
                tabs.forEach((tab) => tab.classList.remove('snu-tab-active'));
                tabs[1].classList.add('snu-tab-active');
                listView.style.display = 'none';
                mapView.style.display = 'block';
                storeStaticData.style.display = 'block';

                window.scrollTo({
                    top: document.getElementById('dev_snu-stores-section').offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const latitude = localStorage.getItem('latitude');
    const longitude = localStorage.getItem('longitude');
    const popup_pincode = localStorage.getItem("popupPincode") ? localStorage.getItem("popupPincode") : 400102;
    const popupPincodeStr = String(popup_pincode).trim();
    const hasValidPopupPincode = /^[1-9][0-9]{5}$/.test(popupPincodeStr);

    if (hasValidPopupPincode) {
        input.value = popupPincodeStr;
        fetchStoreData(popupPincodeStr);
    } else if (latitude && longitude && !isNaN(latitude) && !isNaN(longitude)) {
        fetchStoreData('ignored', parseFloat(latitude), parseFloat(longitude));
        if (popup_pincode) {
            input.value = popup_pincode;
        }
    }
    togglePhysioSection();
});

function updateStoreStatus() {
   const now = new Date();
   const currentHour = now.getHours();
   const currentMinute = now.getMinutes();

   const openHour = 11;
   const closeHour = 21;

   const statusElements = document.querySelectorAll(".dev_all-snup-open-now");

   let isOpen = (
    (currentHour > openHour && currentHour < closeHour) ||
    (currentHour === openHour && currentMinute >= 0) ||
    (currentHour === closeHour && currentMinute === 0)
  );

  statusElements.forEach(el => {
    if (isOpen) {
      el.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
          <circle cx="4" cy="4.74805" r="4" fill="#2E7D32"></circle>
        </svg> Open Now
      `;
    } else {
      let nextOpen = new Date(now);
      if (currentHour >= closeHour) {
        nextOpen.setDate(now.getDate() + 1);
      }
      nextOpen.setHours(openHour, 0, 0, 0);

      const msUntilOpen = nextOpen - now;
      const hoursUntilOpen = Math.floor(msUntilOpen / (1000 * 60 * 60));
      const minutesUntilOpen = Math.floor((msUntilOpen % (1000 * 60 * 60)) / (1000 * 60));

      el.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
          <circle cx="4" cy="4.74805" r="4" fill="#F9A825"></circle>
        </svg> Opens in ${hoursUntilOpen}h ${minutesUntilOpen}m
      `;
    }
  });
}

if (window.innerWidth <= 768) {
  tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.remove('snu-tab-active'));
          tab.classList.add('snu-tab-active');

          if (index === 0) {
              listView.style.display = 'block';
              mapView.style.display = 'none';
              storeStaticData.style.display = 'none';
          } else {
              listView.style.display = 'none';
              mapView.style.display = 'block';
              storeStaticData.style.display = 'block';
              google.maps.event.trigger(map, 'resize');
          }
      });
  });
}

document.getElementById('dev_gps-location-icon')?.addEventListener('click', handleGeolocationClick);
document.getElementById('dev_gps-location-btn')?.addEventListener('click', handleGeolocationClick);

$(document).on('click', '.dev_snu-appointment-btn', function() {
  $(document).find('#store-location').val($(this).data('store-loctitle'));
  $(document).find('#store-id-hidden').val($(this).data('store-locid'));
  
  $("#popup145").show();
  $(".inner-div-benefits-bav").css("display", "block");
  $(".success-overlay").css("display", "none");
  $("#contact-formarchitech-bav").css("display", "block");
});

function initializeSliders() {
  const sliders = document.querySelectorAll('.snu-store-image-slider-contianer');
  
  sliders.forEach((slider, sliderIndex) => {
    const existingDots = slider.parentElement.querySelector('.snu-slider-dots');
    if (existingDots) {
      existingDots.remove();
    }
    
    const images = slider.querySelectorAll('.snu-store-image');
    if (images.length <= 1) return;

    slider.scrollLeft = 0;
    
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'snu-slider-dots';
    
    images.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.className = index === 0 ? 'snu-slider-dot active' : 'snu-slider-dot';
      
      dot.addEventListener('click', () => {
        const scrollPosition = index * images[0].offsetWidth;
        slider.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        
        dotsContainer.querySelectorAll('.snu-slider-dot').forEach((d, i) => {
          d.classList.toggle('active', i === index);
        });
      });
      dotsContainer.appendChild(dot);
    });
    
    slider.parentElement.appendChild(dotsContainer);
    
    slider.addEventListener('scroll', () => {
      const scrollPosition = slider.scrollLeft;
      const imageWidth = images[0].offsetWidth;
      const activeIndex = Math.round(scrollPosition / imageWidth);
      
      if (activeIndex >= 0 && activeIndex < images.length) {
        dotsContainer.querySelectorAll('.snu-slider-dot').forEach((dot, index) => {
          dot.classList.toggle('active', index === activeIndex);
        });
      }
    });
    
    const ensureImagesLoaded = () => {
      let imagesLoaded = 0;
      
      if (images[0].complete) {
        slider.scrollLeft = 0;
        return;
      }
      
      images.forEach(img => {
        if (img.complete) {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            slider.scrollLeft = 0;
          }
        } else {
          img.addEventListener('load', () => {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              slider.scrollLeft = 0;
            }
          });
        }
      });
    };
    
    ensureImagesLoaded();
    
    setTimeout(() => {
      slider.scrollLeft = 0;
      const dots = dotsContainer.querySelectorAll('.snu-slider-dot');
      if (dots.length > 0) {
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === 0);
        });
      }
    }, 300);
  });
}

document.addEventListener('DOMContentLoaded', function() {
    const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
        const addedSliders = document.querySelectorAll('.snu-store-image-slider-contianer:not([data-dots-initialized])');
        if (addedSliders.length) {
            initializeSliders();
            addedSliders.forEach(slider => {
            slider.setAttribute('data-dots-initialized', 'true');
            });
        }
        }
    }
    });
    
    observer.observe(document.getElementById('dev_snu-store-card-parent') || document.body, { 
    childList: true, 
    subtree: true 
    });


    document.querySelectorAll('.dev_ga-snu-appointment-btn').forEach((btn) => {
        btn.addEventListener('click', function() {
            gaEvent('store_visit', [this.getAttribute('data-position'), this.getAttribute('data-href'), "", "", "", ""], false);  
            window.location.href = this.getAttribute('data-href');
        });
    });

    const closeBtn = document.querySelector('.close-popup');

    if (closeBtn) {
        closeBtn.addEventListener('click', hideLocationPopup);
    }
});